module.exports = __webpack_public_path__ + "static/media/duck.7cb5d820.svg";